import { render } from "./UserCard.vue?vue&type=template&id=99f30fe8&scoped=true&ts=true"
import script from "./ts/userCard/userCardHelper.ts?vue&type=script&lang=ts"
export * from "./ts/userCard/userCardHelper.ts?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=99f30fe8&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f30fe8"]])

export default __exports__